import { mainAxios } from "@/mainAxios";

const getRequestConfig = () => ({
  headers: {
    Authorization:
      "Bearer " + localStorage.agenteAccessToken,
  },
});

export const obtenerResumenRedencionMasiva = async (
  payload
) => {
  const { data } = await mainAxios.post(
    "/v1/solicitud/redencion/masiva/resumen",
    payload,
    getRequestConfig()
  );

  return data;
};

export const redimirSolicitudesMasivamenteSSE = async (
  payload,
  onEvent
) => {
  const baseURL = (
    mainAxios.defaults.baseURL || ""
  ).replace(/\/$/, "");

  const response = await fetch(
    `${baseURL}/v1/solicitud/redencion/masiva/stream-sse`,
    {
      method: "POST",
      headers: {
        Authorization:
          "Bearer " + localStorage.agenteAccessToken,
        Accept: "text/event-stream, application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }
  );

  if (!response.ok) {
    const raw = await response.text();

    let message = `Error ${response.status}`;

    try {
      const parsed = JSON.parse(raw);

      message =
        parsed.message ||
        parsed.mensaje ||
        parsed.error ||
        message;
    } catch (error) {
      if (raw) {
        message = raw;
      }
    }

    throw new Error(message);
  }

  if (!response.body) {
    throw new Error(
      "El servidor no inició el stream de redención"
    );
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");

  let buffer = "";

  const procesarEvento = (bloque) => {
    if (!bloque.trim()) return;

    let nombreEvento = "message";
    const dataLines = [];

    bloque.split("\n").forEach((line) => {
      if (line.startsWith("event:")) {
        nombreEvento = line
          .substring(6)
          .trim();
      }

      if (line.startsWith("data:")) {
        dataLines.push(
          line.substring(5).trim()
        );
      }
    });

    if (dataLines.length === 0) return;

    const rawData = dataLines.join("\n");

    let data = rawData;

    try {
      data = JSON.parse(rawData);
    } catch (error) {
      // Si no es JSON, conservamos el texto.
    }

    onEvent(nombreEvento, data);
  };

  let streamFinalizado = false;

  while (!streamFinalizado) {
    const { value, done } =
      await reader.read();

    if (done) {
        streamFinalizado = true;
        continue;
    }

    buffer += decoder
        .decode(value, { stream: true })
        .replace(/\r\n/g, "\n");

    const bloques = buffer.split("\n\n");

    buffer = bloques.pop() || "";

    bloques.forEach(procesarEvento);
  }

  buffer += decoder.decode();

  if (buffer.trim()) {
    procesarEvento(buffer);
  }
};

export const detenerRedencionMasiva = async (
  procesoId
) => {
  const { data } = await mainAxios.get(
    "/v1/solicitud/redencion/masiva/stop",
    {
      params: {
        procesoId,
      },
      ...getRequestConfig(),
    }
  );

  return data;
};
